@if (isLoaded()) {
    <div id="edit-trading-symbols-list-view" class="d-flex flex-column align-items-start justify-content-start p-2">
        <mat-form-field class="w-100">
            <mat-label>Name</mat-label>
            <input type="text" matInput [(ngModel)]="tradingSymbolsListName" />
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="tradingSymbolsListDescription"></textarea>
        </mat-form-field>

        @if (!isNew()) {
            <mat-form-field class="w-100">
                <mat-label>Select csv/xlsx file to update list</mat-label>
                <input
                    type="file"
                    (change)="onFileSelected($event)"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <button mat-raised-button color="primary" class="w-25" (click)="upload()" [disabled]="!file()">
                    <mat-icon>upload</mat-icon>
                    Upload File
                </button>
                <input type="text" hidden matInput />
            </mat-form-field>
        }

        <mat-form-field class="w-100">
            <input matInput type="filter" [(ngModel)]="filterText" placeholder="Filter symbols..." />
        </mat-form-field>
        <mat-checkbox [checked]="showOnlySelected()" (change)="showOnlySelected.set($event.checked)"
            >Show only selected</mat-checkbox
        >

        <table mat-table [dataSource]="listedTradingSymbols()" class="mat-elevation-z8 my-3">
            <ng-container matColumnDef="isSelected">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox
                        [checked]="element.isSelected()"
                        (change)="changeSelection($event.checked, element.name)"
                    ></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>Company</th>
                <td mat-cell *matCellDef="let element">{{ element.company }}</td>
            </ng-container>
            <ng-container matColumnDef="group">
                <th mat-header-cell *matHeaderCellDef>Group</th>
                <td mat-cell *matCellDef="let element">{{ element.group }}</td>
            </ng-container>
            <ng-container matColumnDef="exchange">
                <th mat-header-cell *matHeaderCellDef>Exchange</th>
                <td mat-cell *matCellDef="let element">{{ element.exchange }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">{{ element.type }}</td>
            </ng-container>
            <ng-container matColumnDef="isActive">
                <th mat-header-cell *matHeaderCellDef>Active</th>
                <td mat-cell *matCellDef="let element">{{ element.isActive ? "+" : "-" }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="d-flex flex-row align-items-start justify-content-start gap-3">
            @if (isNew()) {
                <button mat-raised-button color="primary" (click)="create()" [disabled]="!isValid()">
                    <mat-icon>add</mat-icon>
                    Create
                </button>
            }
            @if (!isNew()) {
                <button mat-raised-button color="primary" (click)="update()" [disabled]="!isValid()">
                    <mat-icon>save</mat-icon>
                    Save
                </button>
            }
            <button mat-raised-button (click)="cancel()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
        </div>
    </div>
}
